var map = {
	"./busd.svg": 2003,
	"./crypto-pending.png": 2004,
	"./crypto-reject.png": 2005,
	"./crypto-success.png": 2006,
	"./direpay.svg": 2007,
	"./trx.svg": 2008,
	"./usdc.svg": 2009,
	"./usdt.svg": 2010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;